import api from './apiClient';

// This interface must match your prisma schema for StreamChannel
export interface StreamChannel {
  id: number;
  hashId?: string;
  displayId?: string;
  channelHashId?: string;
  channelDisplayId?: string;
  name: string;
  streamKeyPin: string;
  userId: number;
  createdAt: string;
  updatedAt: string;
  isActive: boolean; 
  billingSuspended?: boolean;
  suspensionReason?: string | null;
  outputLimit?: number;
  cpuLimit?: number;
  hasXmltv: boolean;
  hasGracenote: boolean;
  hlsLimit?: number;
  hlsPlusLimit?: number;
  socialStreamLimit?: number;
  managedServiceLimit?: number;
  managedServiceUpgradeLimit?: number;
  channelSetupFeePaid?: boolean;
  playkasterSetupFeePaid?: boolean;
  outputPackageCode?: string | null;
  pendingOutputPackageCode?: string | null;
  sourceMode?: 'LIVE_STUDIO' | 'PLAYKASTR';
  playkastrActive?: boolean;
  playkastrTierCode?: string | null;
  playkastrAddonId?: number | null;
}

type ChannelRouteTarget = number | string | StreamChannel;

const resolveChannelRouteId = (channel: ChannelRouteTarget) => {
  if (channel && typeof channel === 'object') {
    return String(channel.channelHashId || channel.hashId || channel.id || '');
  }
  return String(channel ?? '');
};

/**
 * Fetches the stream channels for the currently authenticated user.
 * For Broadcasters, this will be 1. For Super Broadcasters, this will be 5.
 */
export const getMyChannels = async (): Promise<StreamChannel[]> => {
  // This corresponds to the new backend route: GET /api/streams/channels
  const { data } = await api.get<StreamChannel[]>('/streams/channels');
  return data;
};

export const resetStreamKey = async (channel: ChannelRouteTarget, password: string): Promise<{ newStreamKeyPin: string }> => {
  const routeId = resolveChannelRouteId(channel);
  const { data } = await api.post(`/users/me/channels/${routeId}/reset-stream-key`, { password });
  return data;
};
